import { render, staticRenderFns } from "./RmaProduct.vue?vue&type=template&id=8f5ab4b2&scoped=true&"
import script from "./RmaProduct.vue?vue&type=script&lang=js&"
export * from "./RmaProduct.vue?vue&type=script&lang=js&"
import style0 from "./RmaProduct.vue?vue&type=style&index=0&id=8f5ab4b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5ab4b2",
  null
  
)

export default component.exports